import axios from '../utils/axios';
import config from '../utils/config';

const USER_RULES_PREFERENCES_URL = config.get('preferences_api', 'rules_preferences_url');
const USER_ACCOUNTS_PREFERENCES_URL = config.get('preferences_api', 'accounts_preferences_url');
const PREFERENCES_USER_ACCOUNT_LIST = config.get('preferences_api', 'accountslist_preferences_url');

async function getUserRulesPreferences (accessToken, username) {
  try {
    const userPreferencesResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: USER_RULES_PREFERENCES_URL,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return userPreferencesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function setUserRulesPreferences (accessToken, username, payload) {
  try {
    const userPreferencesResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: USER_RULES_PREFERENCES_URL,
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return userPreferencesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function setUserAccountsPreferences (accessToken, username, payload) {
  try {
    let {businessAccountId,...requestBody} = payload;
    const userPreferencesResponse = await axios({
      method: 'post',
      responseType: 'json',
      url:config.formUrl(USER_ACCOUNTS_PREFERENCES_URL,payload.businessAccountId),
      data: requestBody,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return userPreferencesResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getUserAccounts (accessToken, username, businessAccountId) {
  try {
    const userPreferencesResponse = await axios({
      method: 'get',
      responseType: 'json',
      url:config.formUrl(PREFERENCES_USER_ACCOUNT_LIST,businessAccountId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return userPreferencesResponse;
  } catch (error) {
    throw error.response;
  }
}

export {
  getUserRulesPreferences,
  setUserRulesPreferences,
  setUserAccountsPreferences,
  getUserAccounts
};
